const map = {
	"./comeback.webp": 1908,
	"./early_bird.webp": 7496,
	"./explorer_10.webp": 7132,
	"./first_practice.webp": 593,
	"./naplan_maths.webp": 1745,
	"./naplan_reader.webp": 7701,
	"./night_owl.webp": 9330,
	"./numeracy_90.webp": 6539,
	"./oc_thinker.webp": 7405,
	"./overall_80.webp": 3821,
	"./perfect_3.webp": 9022,
	"./perfect_score.webp": 5433,
	"./placement_done.webp": 8199,
	"./practice_100.webp": 8346,
	"./questions_1000.webp": 3620,
	"./questions_250.webp": 9528,
	"./questions_50.webp": 8400,
	"./reading_90.webp": 2071,
	"./selective_allrounder.webp": 3050,
	"./streak_100.webp": 6453,
	"./streak_14.webp": 7903,
	"./streak_3.webp": 4115,
	"./streak_30.webp": 2805,
	"./streak_60.webp": 1852,
	"./streak_7.webp": 2175,
	"./tests_1.webp": 9156,
	"./tests_10.webp": 6404,
	"./tests_100.webp": 260,
	"./tests_25.webp": 8128,
	"./tests_50.webp": 1760,
	"./thinking_90.webp": 2133,
	"./warmup_10.webp": 4973,
	"./weekend_warrior.webp": 7217,
	"./weekly_goal.webp": 2994,
	"./writing_90.webp": 6183
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2587;